import { render, staticRenderFns } from "./aufgabe-attachment-vorgang-table.vue?vue&type=template&id=7380d98b"
import script from "./aufgabe-attachment-vorgang-table.vue?vue&type=script&lang=js"
export * from "./aufgabe-attachment-vorgang-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports